import React, { useContext } from "react";
import { AuthContext } from "../app-context/AuthContext";
import { NavLink, useLocation } from "react-router-dom";

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return (
    <div className="w-64 h-full bg-gray-100 p-4">
      <ul>
        <li className="mb-2">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "block p-2 text-white bg-red-500 rounded"
                : "block p-2 text-red-500 rounded hover:bg-gray-200"
            }
          >
            Home
          </NavLink>
        </li>
        <li className="mb-2">
          <NavLink
            to="/watchlist"
            className={({ isActive }) =>
              isActive
                ? "block p-2 text-white bg-red-500 rounded"
                : "block p-2 text-red-500 rounded hover:bg-gray-200"
            }
          >
            Watchlist
          </NavLink>
        </li>
      </ul>
      <div className="absolute bottom-4">
        {user ? (
          <span className="text-gray-500">{user}</span>
        ) : (
          <NavLink
            to="/login"
            className="block p-2 text-red-500 rounded hover:bg-gray-200"
          >
            Guest
          </NavLink>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
